"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOG_POSTS = exports.BLOG_POST = exports.BLOG_TAGS = void 0;
const client_1 = require("@apollo/client");
const blog_1 = require("../fragments/blog");
exports.BLOG_TAGS = (0, client_1.gql) `
  ${blog_1.BLOG_POST_FIELDS}
  query BlogTags {
    blogTags {
      id
      name
    }
  }
`;
exports.BLOG_POST = (0, client_1.gql) `
  ${blog_1.BLOG_POST_FIELDS}
  query BlogPost($id: Int!) {
    blogPost(id: $id) {
      ...BlogPostFields
      relatedBlogPosts {
        ...BlogPostFields
      }
    }
  }
`;
exports.BLOG_POSTS = (0, client_1.gql) `
  ${blog_1.BLOG_POST_FIELDS}
  query BlogPosts($tags: [String]) {
    blogPosts(tags: $tags) {
      ...BlogPostFields
      relatedBlogPosts {
        ...BlogPostFields
      }
    }
  }
`;
